import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message, Modal } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const SAVE_BARCODE_PRODUCT_REQUEST =
  'BarcodeProduct/SAVE_BARCODE_PRODUCT_REQUEST'
const SAVE_BARCODE_PRODUCT_SUCCESS =
  'BarcodeProduct/SAVE_BARCODE_PRODUCT_SUCCESS'
const SAVE_BARCODE_PRODUCT_FAILURE =
  'BarcodeProduct/SAVE_BARCODE_PRODUCT_FAILURE'

const SAVE_BARCODE_PRODUCT_FEATURE_REQUEST =
  'BarcodeProduct/SAVE_BARCODE_PRODUCT_FEATURE_REQUEST'
const SAVE_BARCODE_PRODUCT_FEATURE_SUCCESS =
  'BarcodeProduct/SAVE_BARCODE_PRODUCT_FEATURE_SUCCESS'
const SAVE_BARCODE_PRODUCT_FEATURE_FAILURE =
  'BarcodeProduct/SAVE_BARCODE_PRODUCT_FEATURE_FAILURE'

const GET_BARCODE_BY_ID_REQUEST = 'BarcodeProduct/GET_BARCODE_BY_ID_REQUEST'
const GET_BARCODE_BY_ID_SUCCESS = 'BarcodeProduct/GET_BARCODE_BY_ID_SUCCESS'
const GET_BARCODE_BY_ID_FAILURE = 'BarcodeProduct/GET_BARCODE_BY_ID_FAILURE'

const GET_BARCODE_PRODUCT_REQUEST = 'BarcodeProduct/GET_BARCODE_PRODUCT_REQUEST'
const GET_BARCODE_PRODUCT_SUCCESS = 'BarcodeProduct/GET_BARCODE_PRODUCT_SUCCESS'
const GET_BARCODE_PRODUCT_FAILURE = 'BarcodeProduct/GET_BARCODE_PRODUCT_FAILURE'

const DELETE_BARCODE_BY_ID_REQUEST =
  'BarcodeProduct/DELETE_BARCODE_BY_ID_REQUEST'
const DELETE_BARCODE_BY_ID_SUCCESS =
  'BarcodeProduct/DELETE_BARCODE_BY_ID_SUCCESS'
const DELETE_BARCODE_BY_ID_FAILURE =
  'BarcodeProduct/DELETE_BARCODE_BY_ID_FAILURE'

const DELETE_BARCODE_BRAND_REQUEST =
  'BarcodeProduct/DELETE_BARCODE_BRAND_REQUEST'
const DELETE_BARCODE_BRAND_SUCCESS =
  'BarcodeProduct/DELETE_BARCODE_BRAND_SUCCESS'
const DELETE_BARCODE_BRAND_FAILURE =
  'BarcodeProduct/DELETE_BARCODE_BRAND_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  barcodeDetail: {},
  barcodeProductObj: {
    content: [],
    pageable: {}
  }
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_BARCODE_PRODUCT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_BARCODE_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_BARCODE_PRODUCT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_BARCODE_PRODUCT_FEATURE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_BARCODE_PRODUCT_FEATURE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_BARCODE_PRODUCT_FEATURE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_BARCODE_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_BARCODE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        barcodeDetail: action.payload
      }
    case GET_BARCODE_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_BARCODE_PRODUCT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_BARCODE_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        barcodeProductObj: action.payload
      }
    case GET_BARCODE_PRODUCT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_BARCODE_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_BARCODE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_BARCODE_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_BARCODE_BRAND_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_BARCODE_BRAND_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_BARCODE_BRAND_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

// Action Creators
export const saveBarcodeProduct = (data, action) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_BARCODE_PRODUCT_REQUEST
      })
      const userToken = localStorage.getItem('user-token')
      await API.post(EndPoints.BARCODE + `/saveByAdmin`, data, {
        headers: {
          Authorization: userToken
        }
      })

      dispatch({
        type: SAVE_BARCODE_PRODUCT_SUCCESS
      })
      if (action === 'create') {
        Modal.success({
          title: 'เพิ่มข้อมูลเรียบร้อยแล้ว'
        })
      } else {
        Modal.success({
          title: 'แก้ไขข้อมูลเรียบร้อยแล้ว'
        })
      }
    } catch (err) {
      dispatch({
        type: SAVE_BARCODE_PRODUCT_FAILURE
      })
    }
  }
}

export const saveBarcodeProductFeature = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_BARCODE_PRODUCT_FEATURE_REQUEST
      })
      const userToken = localStorage.getItem('user-token')
      await API.post(EndPoints.BARCODE + `/saveProductFeature`, data, {
        headers: {
          Authorization: userToken
        }
      })

      dispatch({
        type: SAVE_BARCODE_PRODUCT_FEATURE_SUCCESS
      })
    } catch (err) {
      dispatch({
        type: SAVE_BARCODE_PRODUCT_FEATURE_FAILURE
      })
    }
  }
}

export const getBarcodeById = (barcodeId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_BARCODE_BY_ID_REQUEST
      })
      const userToken = localStorage.getItem('user-token')
      const response = await API.get(
        EndPoints.BARCODE + `/adminDetail/${barcodeId}`,
        {
          headers: {
            Authorization: userToken
          }
        }
      )

      if (response.status === 200) {
        dispatch({
          type: GET_BARCODE_BY_ID_SUCCESS,
          payload: response.data
        })
      }
    } catch (err) {
      dispatch({
        type: GET_BARCODE_BY_ID_FAILURE
      })
    }
  }
}

export const getBarcodeProduct = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_BARCODE_PRODUCT_REQUEST
      })
      const userToken = localStorage.getItem('user-token')
      const response = await API.get(EndPoints.BARCODE + `/search`, {
        headers: {
          Authorization: userToken
        },
        params: options
      })

      dispatch({
        type: GET_BARCODE_PRODUCT_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_BARCODE_PRODUCT_FAILURE
      })
    }
  }
}

export const deleteBarcodeById = (barcodeId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BARCODE_BY_ID_REQUEST
      })

      const response = await API.delete(EndPoints.BARCODE + `/${barcodeId}`)

      if (response.status === 200) {
        dispatch({
          type: DELETE_BARCODE_BY_ID_SUCCESS
        })

        Modal.success({
          title: 'ลบข้อมูลเรียบร้อย'
        })
      }
    } catch (err) {
      dispatch({
        type: DELETE_BARCODE_BY_ID_FAILURE
      })
    }
  }
}

export const deleteBarcodeBrand = (barcodeId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BARCODE_BRAND_REQUEST
      })

      await API.delete(EndPoints.BARCODE + `/removeBrand/${barcodeId}`)
      dispatch({
        type: DELETE_BARCODE_BRAND_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_BARCODE_BRAND_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/barcodeProduct.js